import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import {
  selectTargetAccumulatorScheduleData,
  selectTargetAccumulatorScheduleFieldValidation,
  selectTargetAccumulatorScheduleTable,
} from '@/store/targetAccumulator/selectors.ts';
import type { AccumulatorScheduleLine } from '@/store/targetAccumulator/state.ts';

const StrikeUp = ({ legId }: { legId: string }) => {
  const tileId = useTargetAccumulatorTileId();
  const strikeUp = useAppSelector((state) => selectTargetAccumulatorScheduleTable(state, tileId, legId)?.strikeUp);
  const isModified = useAppSelector(
    (state) =>
      selectTargetAccumulatorScheduleData(state, tileId).scheduleCustomFields?.[legId]?.includes('StrikeUp') ?? false,
  );
  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const { validation } = useAppSelector((state) =>
    selectTargetAccumulatorScheduleFieldValidation(state, tileId, legId, 'strikeUpString'),
  );

  const handleStrikeUp = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent(
      'Target Accumulator',
      'Schedule strikeUp changed',
      isDefined(value) ? String(value) : 'null',
    );

    return checkTargetAccumulatorWithTradeCapture({
      schedule: { [legId]: { strikeUp: isDefined(value) ? value : null } as AccumulatorScheduleLine },
    });
  };

  return (
    <div style={{ maxWidth: '5rem' }}>
      <TradeCaptureValidationWrapper validation={validation}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          className={isModified ? 'text-info ' : ''}
          value={isDefined(strikeUp) ? strikeUp : undefined}
          maxDecimals={9}
          onChange={handleStrikeUp}
          size="sm"
          data-e2e="strikeUp"
          data-e2e-is-modified={isModified}
        />
      </TradeCaptureValidationWrapper>
    </div>
  );
};

export default StrikeUp;
